module.exports = __webpack_public_path__ + "src/img/artist/artistpage7.svg?9ab5f880b05f5651f4e11838f56af3e9";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage7.svg
// module id = 125
// module chunks = 0